module.exports = __webpack_public_path__ + "static/media/practice-question-header.6ca5ae39.png";